import { initializeAnalytics } from './initializeAnalytics'
import { ERROR_MESSAGES } from './initializeErrorMessage'
import { initializeScrollToTop } from './initializeScrollToTop'

export const initializeApp = async () => {
  try {
    // 스크롤 초기화
    initializeScrollToTop()

    // 애널리틱스 초기화
    initializeAnalytics()

    // 여기에 앱 초기화 로직을 추가합니다.
    // 예: API 클라이언트 설정, 환경 변수 검증 등
    return true
  } catch (error) {
    console.error('App initialization failed:', error)
    throw new Error(ERROR_MESSAGES.APP_LOAD_FAILED)
  }
}
